/* History object that helps controling the browser navigation */
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();
export default history;
